/**
 * The product's name, in one place.
 *
 * Same reasoning as lib/urls.js: the fork inherited ~55 hardcoded "Measure
 * Marketer" strings across the dashboard, the login screen, the embed snippets
 * tenants paste into their own sites, and the Razorpay checkout title. Renaming
 * by grep is how you miss the one in a payment dialog.
 *
 * `parent` is deliberately still Measure Marketer - that is who builds this, and
 * it stays true on the fork.
 */
export const BRAND = {
  name: 'Cookiebees',
  tagline: 'Attribution-first CRM',
  parent: 'Measure Marketer',
  supportEmail: 'support@cookiebees.io',
};
